import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-paper-dark pt-16 pb-28 md:py-16 px-6 md:px-12 border-t border-gray-200 mt-0" data-id="element-156" data-mp="32u0lk5cflfhj">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-157" data-mp="32nukakr5twzs">
        <Logo data-id="element-158" data-mp="36pftnw4hjt58" />
        <div className="text-sm text-text-muted text-center md:text-right font-medium" data-id="element-159" data-mp="36oxyz3xh1mzf">
          <p data-id="element-160" data-mp="3ufa4y995p9nd">
            &copy; {new Date().getFullYear()} Author Leverage. All rights
            reserved.
          </p>
          <p className="mt-2 text-seaglass" data-id="element-161" data-mp="38zawx2kd95j">The path after the book.</p>
        </div>
      </div>
    </footer>;
}